import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import MaintenanceDetail from './MaintenanceDetail'
import SparepartsModal from './SparepartsModal.vue'
import { exportMaintainRecord } from '@/api/api'
import { MaintainRecordServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import dayjs from 'dayjs'

const mrsp = new MaintainRecordServiceProxy()
@Component({
  components: {
    SparepartsModal,
    MaintenanceDetail
  }
})
export default class Maintenance extends Vue { // 保养项目
  @Prop({ default: "" }) readonly deviceId
  @Prop({ default: () => ({}) }) readonly selectDevice: Object;

  @Watch('deviceId')
  getData() {
    this.reload()
  }

  created(){
    if(this.deviceId !== ""){
      this.reload()
    }
  }

  reload(){
    this.filters = {
      current: 1,
      size: 10
    }
    this.keywords = ""
    this.total = 0
    this.getListPage()
  }

  getListPage(){
    const maintainRecord = {
      deviceId: this.deviceId,
      deviceTypeId: "",
      filterPlus: false,
      keyWord: "",
      param: {},
      recordStatus: ""
    }as any
    this.loading = true
    mrsp.queryMaintainRecordPage(this.filters.current,maintainRecord,this.filters.size).then(res =>{
      if(res){
        this.dataSource = res.records
        this.detailList = []
        this.total = Number(res.total)
        this.loading = false
        if(res.records && res.records.length > 0){
          this.selectId = res.records[0].id
          this.clickRow(this.selectId)
        }
      }
    })
  }

  get columns() {
    return [
      {
        title: this.$t('page_tenant_operation'),
        key: 'action',
        fix: 'left',
        width: 80,
        customRender: (text, record) => {
          return (
            <a onClick={e => {e.stopPropagation();this.view(record);}}>
              {this.$t('page_plan_maintenance_see_the_attachment')}
            </a>
          )
        }
      },      {
        title: this.$t('page_plan_maintenance_task_number'),
        dataIndex: 'recordCode',
        key: 'recordCode',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_application_No'),
        dataIndex: 'planCode',
        key: 'planCode',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_program'),
        dataIndex: 'projectName',
        key: 'projectName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_maintenance_start_time'),
        dataIndex: 'startTime',
        key: 'startTime',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { dayjs(value).format('YYYY-MM-DD HH:mm:ss') }
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_maintenance_completion_time'),
        dataIndex: 'endTime',
        key: 'endTime',
        width: 200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { dayjs(value).format('YYYY-MM-DD HH:mm:ss') }
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_whether_it_is_postponed_or_not'),
        dataIndex: 'isDelayName',
        key: 'isDelayName',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_days_of_delay'),
        dataIndex: 'delayDays',
        key: 'delayDays',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_reasons_for_the_delay'),
        dataIndex: 'delayReason',
        key: 'delayReason',
        width: 200,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_person_in_charge_of_maintenance'),
        dataIndex: 'maintainUserName',
        key: 'maintainUserName',
        width: 200,
        ellipsis: true
      }
    ]
  }

  filters = {
    current: 1,
    size: 10
  }
  keywords = ""
  total = 0
  loading = false
  dataSource = []
  selectId = ""
  detailLoading = false
  detailList = []
  spareData = []
  spareVisible = false
  resizeTimer = null
  tableScrollHeight = 170

  changeY(){
    if(this.resizeTimer){
      clearTimeout(this.resizeTimer)
      this.resizeTimer = null
    }
    this.resizeTimer = setTimeout(function() {
      const div = document.getElementById('ware-topmodal')
      this.tableScrollHeight = div.clientHeight
      const bodyTableBody: any = document.querySelector('#ware-topmodal .ant-table-body')
      if(bodyTableBody) {
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
      }
    },100)
  }

  pageIndexchange(value){
    this.filters = {
      current: value,
      size: 10
    }
    this.selectId = ""
    this.getListPage()
  }

  showTotal(total) {
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  clickRow(id){
    this.selectId = id
    this.detailLoading = true
    this.detailList = []
    mrsp.getMaintainRecord(id).then(res =>{
      this.detailList = res.maintainRecordItemVoList
      this.detailLoading = false
    })
  }

  view(record) {
    this.clickRow(record.id)
    mrsp.queryMaintainRecordMaterialList(record.id).then(res => {
      this.spareData = res
      this.spareVisible = true
    })
  }

  spareClose(){
    this.spareVisible = false
  }

  export(){
    const data = {
      deviceId: this.deviceId,
      deviceTypeId: "",
      exportSelected: false,
      keyWord: "",
      recordStatus: 0,
      selectedRecords: []
    }
    exportMaintainRecord(data).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_equipment_maintain_records')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  render() {
    return (
      <div style="height: 100%;padding-top: 8px;overflow-y: auto;">
        <a-button type="default" style="margin-bottom:8px" onClick={() => this.export()}>{ this.$t('page_product_export')}</a-button>
        <div style="height: 260px;overflow-y: auto;overflow-x: hidden;position: relative;">
          <ml-table
            size="small"
            rowKey="id"
            defaultExpandAllRows={true}
            canChangeColWidth={true}
            loading={this.loading}
            dataSource={this.dataSource}
            columns={this.columns}
            scroll={{ y: 170, x: 1880 }}
            selectRowKey={this.selectId}
            customRow={(record) => {
              return {
                on: { // 事件
                  click: () => this.clickRow(record.id),      // 点击行
                },
              };
            }}
          ></ml-table>
          <a-pagination
            style="position:absolute;bottom: 4px;right: 20px"
            total={this.total}
            pageSize={this.filters.size}
            current={this.filters.current}
            show-total={total => `${this.showTotal(total)}`}
            onChange={this.pageIndexchange}
            onShowSizeChange={this.pageIndexchange}
          ></a-pagination>
        </div>
        <div v-resize={{axis: 'y', cb: this.changeY }}></div>
        <div>
          <maintenance-detail
            loading={this.detailLoading}
            data={this.detailList}
          ></maintenance-detail>
        </div>
        {
          this.spareVisible ?
            <spareparts-modal
              visible={this.spareVisible}
              dataSource={this.spareData}
              onClose={() => this.spareClose()}
            ></spareparts-modal> : null
        }
      </div>
    )
  }
}
